import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ChangePricePlanBlockData from '../../../Models/Content/ChangePricePlanBlockData';
import ChangePricePlanMain from './ChangePricePlanMain';
import './changePricePlan.scss';

export default class ChangePricePlanBlock extends EpiComponent<ChangePricePlanBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    let cssClasses: Array<string> = ['change-price-plan-container'];
    return (
      <div className={cssClasses.join(' ')}>
        <ChangePricePlanMain context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
